import React from 'react'
import ReportCreator from './ReportCreator';
import reportService from '../../services/reportService';
import Layout from '../common/Layout';

export default () => {
    return <Layout>
        <ReportCreator reportService={reportService} />
    </Layout>
};